import logo from './logo.svg';
import './App.css';
import { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import { motion } from 'framer-motion';
import LoginModal from './Components/Login/LoginModal';
import Homepage from './Pages/Homepage/Homepage';
import ListAcademicians from './Pages/ListAcademicians/ListAcademicians';
import SendEmails from './Pages/SendEmails/SendEmails';

function App() {
  const MotionButton = motion(Button);
  const [showLogin, setShowLogin] = useState(false);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    // Check if user is logged in
    const user = localStorage.getItem('user');
    if (user) {
      setIsAuthenticated(true);
    }
  }, []);

  const handleLoginClick = () => {
    setShowLogin(true);
  };

  const handleLoginSuccess = () => {
    setIsAuthenticated(true);
    setShowLogin(false);
  };

  const handleLogout = () => {
    localStorage.removeItem('user');
    setIsAuthenticated(false);
  };

  // Login page component
  const LoginPage = () => (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p className="text-light">Content Editor</p>
        <MotionButton
          className="mt-4"
          variant="light"
          size="lg"
          whileHover={{ scale: 1.06 }}
          whileTap={{ scale: 0.98 }}
          id="loginButton"
          onClick={handleLoginClick}
        >
          Login
        </MotionButton>
        <LoginModal 
          show={showLogin} 
          onClose={() => setShowLogin(false)}
          onLoginSuccess={handleLoginSuccess}
        />
      </header>
    </div>
  );

  return (
    <Router>
      <Routes>
        <Route 
          path="/" 
          element={isAuthenticated ? <Navigate to="/homepage" /> : <LoginPage />} 
        />
        <Route 
          path="/homepage" 
          element={isAuthenticated ? <Homepage onLogout={handleLogout} /> : <Navigate to="/" />} 
        />
        <Route 
          path="/journal/list-academicians" 
          element={isAuthenticated ? <ListAcademicians /> : <Navigate to="/" />} 
        />
        <Route 
          path="/journal/send-emails" 
          element={isAuthenticated ? <SendEmails /> : <Navigate to="/" />} 
        />
      </Routes>
    </Router>
  );
}

export default App;